<obg-m-dialog-layout
	dialogId="terms-and-conditions-outdated-version"
	[navbar]="showNavbar"
	[navbarOptions]="navbarOptions"
	[titleText]="showNavbar ? ('terms-and-conditions.title' | translate)  : ''"
	test-id="deposit"
>
	<header>
		<p>{{ 'terms-and-conditions.history-modal-subtitle' | translate }}</p>
	</header>

	<obg-m-terms-and-conditions-current-version-container [document]="data.document" [currentVersion]="data.version">
	</obg-m-terms-and-conditions-current-version-container>
</obg-m-dialog-layout>
